// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DN2a","col":"styles_col__3SNgh"};